import { forwardRef, type Ref, type SVGProps } from "react";
const IconPhotosFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 5H8a2.006 2.006 0 0 0-2 2v3H4a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h19a2.006 2.006 0 0 0 2-2v-2h3a2.006 2.006 0 0 0 2-2V7a2.006 2.006 0 0 0-2-2M13 9a2 2 0 1 1-2 2 2 2 0 0 1 2-2m10 17H4V12h2v10a2.006 2.006 0 0 0 2 2h15Zm5-10v6H9.586l7.707-7.707a1 1 0 0 1 1.414 0L21 16.586l3.293-3.293a1 1 0 0 1 1.414 0L28 15.586Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPhotosFilledSVG);
ForwardRef.displayName = "IconPhotosFilled";
export { ForwardRef as IconPhotosFilled };
